export default __webpack_public_path__ + "static/media/plain-sticker-G.1ccf91c7.png";